import { translateText } from "./translateText";

export const formatText = (languageData, text, capitalize = true) => {
    if (!text) return text;
    const languageOption = localStorage.getItem("languageOption");
    const newStr = capitalize ? text
        .replace(/-/g, " ")
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ") : text;
    if (!languageData?.language_translation) return newStr;
    return translateText(languageData?.language, newStr);
};
